<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-60">
      <tour-list></tour-list>
    </div>
    <div class="md-layout-item md-size-40">
      <tour-management></tour-management>
    </div>
  </div>
</template>

<script>
import TourList from "./TourList";
import TourManagement from "./TourManagement";

export default {
  components: {
    TourList,
    TourManagement
  }
};
</script>
